import React from "react";
import Navbar from "../components/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faClock, faMap } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import Footer from "../components/Footer";

const Deals = () => {
  const countryOptions = [
    "Destination",
    "Italy",
    "France",
    "Switzerland",
    "Thailand",
    "Australia",
    "Pakistan",
    "Indonesia",
    "Malaysia",
    "Singapore",
  ];
  const PriceRangeOptions = [
    "Price Range",
    "$100 - $250",
    "$250 - $500",
    "$500 - $1,000",
    "$1,000 - $2,500",
    "$2,500+",
  ];
  return (
    <div>
      <Navbar />
      <section
        style={{
          backgroundImage: `url(${"https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/heading-bg.jpg"})`,
        }}
        className="text-center px-4 h-[70vh] md:h-screen bg-center bg-no-repeat bg-cover flex flex-col items-center justify-center"
      >
        <p className="text-xl font-semibold text-gray-200">
          Discover Our Weekly Offers
        </p>
        <h1 className="text-5xl font-bold mt-5 text-gray-200">
          Amazing Prices & More
        </h1>
        <button
          className="bg-transparent mt-5  hover:bg-cyan-500 hover:text-
        white border border-white hover:border-cyan-500 text-white transition-all h-12   text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold"
        >
          Discover More
        </button>
      </section>
      <section className="bg-gray-700 flex flex-col items-center ">
        <div className="flex flex-col md:flex-row bg-cyan-500 text-white w-[97%] max-w-[560px] md:min-w-[85%] px-12 md:px-8 items-center justify-between py-8 md:py-5 mx-3 rounded-b-3xl">
          <h1 className="font-bold text-xl ">Sort Deals By:</h1>
          <div className="flex flex-col md:flex-row w-full md:w-[60%] justify-between">
            <div className="flex flex-col w-full md:w-[48%] ">
              <select className=" border-none mt-5 bg-transparent text-white">
                {countryOptions.map((option, index) => (
                  <option className="bg-cyan-500" key={index}>
                    {option}
                  </option>
                ))}
              </select>
              <div className="w-full mt-3 h-[1px] bg-white"></div>
            </div>
            <div className="w-full md:w-[48%]">
              <select className=" border-none w-full mt-5 bg-transparent text-white">
                {PriceRangeOptions.map((option, index) => (
                  <option className="bg-cyan-500" key={index}>
                    {option}
                  </option>
                ))}
              </select>
              <div className="w-full mt-3 h-[1px] bg-white"></div>
            </div>
          </div>
          <button
            className="bg-transparent mt-5 md:ml-3 w-full md:w-auto hover:bg-gray-200 hover:text-
        white border border-white hover:border-cyan-500 text-white hover:text-gray-800 transition-all    text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold"
          >
            Search Results
          </button>
        </div>
        <div className=" mt-16 text-white">
          <h1 className="text-3xl text-center font-semibold">
            Best Weekly Offers In Each City
          </h1>
          <p className=" text-center">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore.
          </p>
          <div className="mt-8 grid grid-cols-1 place-items-center md:grid-cols-2">
            <div className="bg-gray-200 rounded-3xl text-gray-800 flex flex-col md:flex-row max-w-[550px] m-2">
              <div className=" w-full md:w-[40%]  pb-0 md:pb-10">
                <img
                  className="h-[30%] md:h-full w-full rounded-t-3xl md:rounded-l-3xl"
                  src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/deals-01.jpg"
                  alt="Deals"
                />
              </div>
              <div className="p-6 md:pr-0 md:py-6 md:pl-6 flex flex-col justify-between items-start w-full md:w-[60%]">
                <p className="text-cyan-500">Limited Offer Today</p>
                <h1 className="font-bold text-2xl">Glasgow City Lorem</h1>
                <div className="flex justify-between mt-3 w-full  md:w-[70%]">
                  <div className="flex">
                    <FontAwesomeIcon icon={faClock} />
                    <p className="ml-1">5 Days</p>
                  </div>
                  <div className="flex">
                    <FontAwesomeIcon icon={faMap} />
                    <p className="ml-1">5 Days</p>
                  </div>
                </div>
                <p className="mt-4">
                  Lorem ipsum dolor sit amet dire consectetur adipiscing elit.
                </p>
                <button
                  className="bg-cyan-500 mt-5 w-full  md:w-[auto]  hover:bg-gray-200 hover:text-
        white border  hover:border-cyan-500 text-white hover:text-cyan-500 transition-all    text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold"
                >
                  Make a Reservation
                </button>
              </div>
            </div>

            <div className="bg-gray-200 rounded-3xl text-gray-800 flex flex-col md:flex-row max-w-[550px] m-2">
              <div className=" w-full md:w-[40%]  pb-0 md:pb-10">
                <img
                  className="h-[50%] md:h-full w-full rounded-t-3xl md:rounded-l-3xl"
                  src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/deals-01.jpg"
                  alt="Deals"
                />
              </div>
              <div className="p-6 md:pr-0 md:py-6 md:pl-6 flex flex-col justify-between items-start w-full md:w-[60%]">
                <p className="text-cyan-500">Limited Offer Today</p>
                <h1 className="font-bold text-2xl">Glasgow City Lorem</h1>
                <div className="flex justify-between mt-3 w-full  md:w-[70%]">
                  <div className="flex">
                    <FontAwesomeIcon icon={faClock} />
                    <p className="ml-1">5 Days</p>
                  </div>
                  <div className="flex">
                    <FontAwesomeIcon icon={faMap} />
                    <p className="ml-1">5 Days</p>
                  </div>
                </div>
                <p className="mt-4">
                  Lorem ipsum dolor sit amet dire consectetur adipiscing elit.
                </p>
                <button
                  className="bg-cyan-500 mt-5 w-full  md:w-[auto]  hover:bg-gray-200 hover:text-
        white border  hover:border-cyan-500 text-white hover:text-cyan-500 transition-all    text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold"
                >
                  Make a Reservation
                </button>
              </div>
            </div>

            <div className="bg-gray-200 rounded-3xl text-gray-800 flex flex-col md:flex-row max-w-[550px] m-2">
              <div className=" w-full md:w-[40%]  pb-0 md:pb-10">
                <img
                  className="h-[50%] md:h-full w-full rounded-t-3xl md:rounded-l-3xl"
                  src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/deals-01.jpg"
                  alt="Deals"
                />
              </div>
              <div className="p-6 md:pr-0 md:py-6 md:pl-6 flex flex-col justify-between items-start w-full md:w-[60%]">
                <p className="text-cyan-500">Limited Offer Today</p>
                <h1 className="font-bold text-2xl">Glasgow City Lorem</h1>
                <div className="flex justify-between mt-3 w-full  md:w-[70%]">
                  <div className="flex">
                    <FontAwesomeIcon icon={faClock} />
                    <p className="ml-1">5 Days</p>
                  </div>
                  <div className="flex">
                    <FontAwesomeIcon icon={faMap} />
                    <p className="ml-1">5 Days</p>
                  </div>
                </div>
                <p className="mt-4">
                  Lorem ipsum dolor sit amet dire consectetur adipiscing elit.
                </p>
                <button
                  className="bg-cyan-500 mt-5 w-full  md:w-[auto]  hover:bg-gray-200 hover:text-
        white border  hover:border-cyan-500 text-white hover:text-cyan-500 transition-all    text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold"
                >
                  Make a Reservation
                </button>
              </div>
            </div>

            <div className="bg-gray-200 rounded-3xl text-gray-800 flex flex-col md:flex-row max-w-[550px] m-2">
              <div className=" w-full md:w-[40%]  pb-0 md:pb-10">
                <img
                  className="h-[50%] md:h-full w-full rounded-t-3xl md:rounded-l-3xl"
                  src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/deals-01.jpg"
                  alt="Deals"
                />
              </div>
              <div className="p-6 md:pr-0 md:py-6 md:pl-6 flex flex-col justify-between items-start w-full md:w-[60%]">
                <p className="text-cyan-500">Limited Offer Today</p>
                <h1 className="font-bold text-2xl">Glasgow City Lorem</h1>
                <div className="flex justify-between mt-3 w-full  md:w-[70%]">
                  <div className="flex">
                    <FontAwesomeIcon icon={faClock} />
                    <p className="ml-1">5 Days</p>
                  </div>
                  <div className="flex">
                    <FontAwesomeIcon icon={faMap} />
                    <p className="ml-1">5 Days</p>
                  </div>
                </div>
                <p className="mt-4">
                  Lorem ipsum dolor sit amet dire consectetur adipiscing elit.
                </p>
                <button
                  className="bg-cyan-500 mt-5 w-full  md:w-[auto]  hover:bg-gray-200 hover:text-
        white border  hover:border-cyan-500 text-white hover:text-cyan-500 transition-all    text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold"
                >
                  Make a Reservation
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex mt-5 mb-10 items-center justify-center">
              <NavLink>
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className=" text-cyan-500  transition-all hover:text-white  hover:bg-cyan-500 rounded-full px-5 py-4 text-center mx-2 "
                />
              </NavLink>
              <NavLink
                className={
                  "border border-cyan-500 text-cyan-500 bg-transparent rounded-full px-5 py-3 text-center mx-2 hover:bg-cyan-500 hover:text-white transition-all"
                }
              >
                1
              </NavLink>
              <NavLink
                className={
                  "border border-cyan-500 text-white bg-cyan-500 rounded-full px-5 py-3 text-center mx-2 "
                }
              >
                2
              </NavLink>
              <NavLink
                className={
                  "border border-cyan-500 text-cyan-500 bg-transparent rounded-full px-5 py-3 text-center mx-2 hover:bg-cyan-500 hover:text-white transition-all"
                }
              >
                3
              </NavLink>
              <NavLink>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className=" text-cyan-500 transition-all hover:text-white  hover:bg-cyan-500 rounded-full px-5 py-4 text-center mx-2 "
                />
              </NavLink>
            </div>
      </section>
       <section
        className=" flex flex-col md:flex-row  justify-between items-center text-gray-200 py-20 px-12  bg-center"
        style={{
          backgroundImage: `url(${"https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/cta-bg.jpg"})`,
        }}
      >
        <div className="flex flex-col items-center md:items-start text-center md:text-start">
          <h1 className="text-5xl font-bold">Are You Looking To Travel ?</h1>
          <p className="mt-5 text-lg font-bold">
            Make A Reservation By Clicking The Button
          </p>
        </div>
        <button className="bg-transparent mt-5 md:mt-0 hover:bg-white hover:text-cyan-500 border border-white text-white transition-all h-12   text-center py-2 px-3 md:px-5 rounded-3xl md:rounded-full font-medium md:font-semibold">
          Book Yours Now
        </button>
      </section>
      <Footer/>
    </div>
  );
};

export default Deals;
